// This icon file is generated automatically.
var DrrpDrrregbookIconOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 40 40", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M27.5 3.75v2.5h6.74c.75 0 1.25.5 1.25 1.25V35c0 .75-.5 1.25-1.25 1.25H5.76c-.75 0-1.25-.5-1.25-1.25V7.5c0-.75.5-1.25 1.25-1.25h6.74v-2.5h15zm-15 5H7.01v25H33v-25H27.5v2.5h-15v-2.5zm10 17.5v2.5h-10v-2.5h10zm0-5v2.5h-10v-2.5h10zm5-5v2.5h-15v-2.5h15zm-2.5-10H15v2.5h10v-2.5z", "fill-rule": "nonzero" } }] }, "name": "drrp-drrregbook-icon", "theme": "outlined" };
export default DrrpDrrregbookIconOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/DrrpDrrregbookIconOutlined.js
// module id = 2558
// module chunks = 0